<template>
  <div class="share-app">
    <div class="app-banner-bg">
      <div class="app-banner">
        <img src="../assets/logo.png" alt="" />
        <p>{{ $i18n.t("app_name") }}</p>
        <div class="open" v-on:click="handleClickOpen()">
          <p>{{ $i18n.t("open") }}</p>
        </div>
      </div>
    </div>
    <div class="speed-area">
      <div class="speed-area-download">
        <p class="title">{{ $i18n.t("download") }}</p>
        <p class="unit">{{ this.unit }}</p>
        <p class="value">{{ this.download }}</p>
      </div>
      <div class="speed-area-upload">
        <p class="title">{{ $i18n.t("upload") }}</p>
        <p class="unit">{{ this.unit }}</p>
        <p class="value">{{ this.upload }}</p>
      </div>
    </div>
    <div class="speed-quota">
      <p class="ping">{{ this.ping }}</p>
      <p class="separator">|</p>
      <p class="jitter">{{ this.jitter }}</p>
      <p class="separator">|</p>
      <p class="loss">{{ this.loss }}</p>
    </div>
    <div class="lottie-area" ref="speedLevel"></div>
    <div class="share-content">
      {{ $i18n.t("share_content", { "0": this.bandwidth, "1": this.percent }) }}
    </div>
    <div class="test-btn" v-on:click="handleClickOpen()">
      <p>{{ $i18n.t("start_test") }}</p>
    </div>
    <div class="share-bg">
      <img class="share-bg-img" src="../assets/share_bg.png" alt="" />
    </div>
  </div>
</template>

<script>
import appIconImage from "../assets/logo.png";
import lottie from "lottie-web";
import animationDataLevel1 from "../lottie/Animation_SpeedLevel1_Snail.json";
import animationDataLevel2 from "../lottie/Animation_SpeedLevel2_Bicycle.json";
import animationDataLevel3 from "../lottie/Animation_SpeedLevel3_Motorcycle.json";
import animationDataLevel4 from "../lottie/Animation_SpeedLevel4_Car.json";
import animationDataLevel5 from "../lottie/Animation_SpeedLevel5_Airplane.json";
import animationDataLevel6 from "../lottie/Animation_SpeedLevel6_Rocket.json";

export default {
  name: "ShareAPP",
  components: {},
  props: {},
  beforeCreate() {
    let locale = this.$route.params.lang
      ? this.$route.params.lang
      : this.$route.query.lang;
    if (locale && locale.length > 0) {
      localStorage.setItem("locale", locale);
      this.$i18n.locale = locale;
    }

    this.download = this.$route.query.download;
    this.unit = this.$route.query.unit;
    this.upload = this.$route.query.upload;
    this.ping = this.$route.query.ping;
    this.jitter = this.$route.query.jitter;
    this.loss = this.$route.query.loss;
    this.bandwidth = this.$route.query.bandwidth;
    this.percent = this.$route.query.percent;
    this.level = this.$route.query.level;
  },
  created() {},
  mounted() {
    lottie.loadAnimation({
      container: this.$refs.speedLevel,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: this.animations[this.level],
    });
  },
  data: function() {
    return {
      animations: {
        1: animationDataLevel1,
        2: animationDataLevel2,
        3: animationDataLevel3,
        4: animationDataLevel4,
        5: animationDataLevel5,
        6: animationDataLevel6,
      },
      shareTitle: this.$i18n.t("title"),
      shareDescription: this.$i18n.t("description"),
      shareImage: process.env.VUE_APP_DOMAIN + appIconImage,
    };
  },
  methods: {
    handleClickOpen() {
      let itmsLink =
        "https://apps.apple.com/app/apple-store/id" + process.env.VUE_APP_ID;
      window.location.href = itmsLink;
    },
  },
  metaInfo() {
    return {
      title: this.shareTitle,
      meta: [
        {
          name: "description",
          content: this.shareDescription,
        },
        {
          property: "og:title",
          content: this.shareTitle,
        },
        {
          property: "og:description",
          content: this.shareDescription,
        },
        {
          property: "og:image",
          content: this.shareImage,
        },
        {
          name: "twitter:card",
          content: "summary",
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.share-app {
  background-color: #22262d;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  text-align: center;
  overflow-x: hidden;
}
.app-banner-bg {
  width: 100%;
  height: 64px;
  text-align: center;
  background-color: #ffffff;
}
.app-banner {
  min-width: 325px;
  max-width: 414px;
  height: 100%;
  text-align: left;
  margin: 0 auto;
  position: relative;
}
.app-banner img {
  display: inline-block;
  width: 46px;
  height: 46px;
  padding: 9px 0px 9px 16px;
  vertical-align: middle;
}
.app-banner p {
  display: inline-block;
  font-size: 18px;
  font-weight: 600;
  color: rgba(34, 38, 45, 1);
  line-height: 64px;
  padding: 0px 0px 0px 12px;
  vertical-align: middle;
}
.app-banner .open {
  min-width: 64px;
  height: 32px;
  background: rgba(12, 194, 105, 1);
  border-radius: 18px;
  position: absolute;
  top: 16px;
  right: 16px;
  text-align: center;
}
.app-banner .open p {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 32px;
  padding: 0;
}
.speed-area {
  text-align: center;
  margin-top: 24px;
}
.speed-area .title {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  color: rgba(239, 246, 255, 1);
  line-height: 18px;
  padding-top: 16px;
  padding-right: 2px;
}
.speed-area .unit {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  color: rgba(128, 143, 163, 1);
  line-height: 18px;
}
.speed-area .value {
  font-size: 32px;
  font-weight: bold;
  line-height: 40px;
  padding-top: 8px;
}
.speed-area-download {
  display: inline-block;
  min-width: 160px;
  height: 100px;
}
.speed-area-download .value {
  color: rgba(12, 194, 105, 1);
}
.speed-area-upload {
  display: inline-block;
  min-width: 160px;
  height: 100px;
}
.speed-area-upload .value {
  color: rgba(124, 90, 213, 1);
}
.speed-quota {
  text-align: center;
}
.speed-quota p {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 36px;
  min-width: 120px;
}
.speed-quota .separator {
  font-size: 10px;
  min-width: 1px;
}
.share-content {
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 18px;
  max-width: 300px;
  text-align: center;
  margin: 0 auto;
}
.share-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 539px;
  z-index: 1;
}
.share-bg-img {
  max-width: 414px;
}
.test-btn {
  position: relative;
  width: 260px;
  height: 48px;
  background: linear-gradient(
    270deg,
    rgba(100, 222, 144, 1) 0%,
    rgba(81, 232, 213, 1) 100%
  );
  border-radius: 26px;
  text-align: center;
  margin: 48px auto;
  z-index: 2;
}
.test-btn p {
  font-size: 18px;
  color: rgba(37, 44, 55, 1);
  line-height: 48px;
}
.lottie-area {
  width: 140px;
  height: 140px;
  margin: 40px auto 12px auto;
}
</style>
